import React from 'react';
import { Image, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import styles from './Header.module.scss';
import SMlogo from '../../assets/images/SM-logo-xs.png';

export default () => (
  <div>
    <div className={styles.logo}>
      <Col
        xs={12}
        sm={10}
        md={9}
        className='mx-auto d-flex align-items-center'
        style={{ height: '4em' }}
      >
        <NavLink exact to='/'>
          <Image src={SMlogo} />
        </NavLink>
      </Col>
    </div>
  </div>
);
